/**
 * 单店营收监控 - 组件默认显示顺序（GIS 与 HIS 对齐：门店信息概览为首卡）
 * 用于 wrapLayout 布局，支持拖拽排序时作为默认顺序
 */
export function mergeComponentOrderWithDefaults(
  order: string[] | undefined,
  defaultList: readonly string[],
): string[] {
  if (!Array.isArray(defaultList)) {
    return [];
  }
  const allowed = new Set<string>(defaultList);
  const seen = new Set<string>();
  const result: string[] = [];
  if (Array.isArray(order) && order.length > 0) {
    for (const id of order) {
      if (typeof id !== "string" || !allowed.has(id) || seen.has(id)) continue;
      seen.add(id);
      result.push(id);
    }
  }
  for (const id of defaultList) {
    if (!seen.has(id)) {
      result.push(id);
    }
  }
  const lead = "store-overview";
  const leadIdx = result.indexOf(lead);
  if (leadIdx > 0) {
    result.splice(leadIdx, 1);
    result.unshift(lead);
  }
  return result;
}

export const DEFAULT_COMPONENT_ORDER = [
  "store-overview",
  "order-traffic",
  "room-status",
  "room-status-recently",
  "room-health",
  "hourly-price-by-room",
  "channel-price",
  "revpar",
  "customer-source",
  "discount-analysis",
  "occupancy-analysis",
  "operation-efficiency",
  "channel-info",
  "channel-analysis",
] as const;

export type ComponentTypeId = (typeof DEFAULT_COMPONENT_ORDER)[number];
